import ErrorMessage from "../components/Error/ErrorMessage";

function PageNotFound() {
  return <ErrorMessage />;
}

export default PageNotFound;
